import { MenuItem, Typography, Box, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { joinList } from "lib/join-list"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function FieldOption({ option, ...props }) {
    const { selectedOption, multiple } = useBoundContext()
    const [sheet] = useBoundValue("importFromSheet")
    const [row] = useBoundValue("headerRow")
    const [uniqueValues] = useBoundValue("uniqueValues")

    const possibleValuesRaw = Object.keys(uniqueValues[option])
    const possibleValues = possibleValuesRaw.filter((value) => value !== "null")
    const isUnique = possibleValues.length >= sheet.rowCount - row
    const isSelected = !multiple ? selectedOption === option : selectedOption.find((selected) => option == selected)

    return (
        <MenuItem divider sx={{ py: 0.4 }} {...props}>
            <Stack direction="row" alignItems="center">
                <Box width={24} component="span" sx={{ lineHeight: 0 }}>
                    {isSelected && <Iconify sx={{ color: "primary.main" }} icon="mdi:check" />}
                </Box>
                <Stack>
                    <Typography variant="body2">
                        <strong>{option}</strong>
                        <small>
                            {isUnique
                                ? " (Unique)"
                                : ` (${possibleValues.length} ${"value".pluralize(possibleValues.length)})`}
                        </small>
                    </Typography>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ textOverflow: "ellipsis", maxWidth: 450, overflow: "hidden" }}
                    >
                        {possibleValues.length > 0 ? `e.g. ${joinList(possibleValues.slice(0, 4))}` : "No values"}
                    </Typography>
                </Stack>
            </Stack>
        </MenuItem>
    )
}
